import AsyncComponent from './AsyncTask.vue'

const AsyncTask = {
  install(Vue) {
    Vue.component('AsyncTaskBox', AsyncComponent)
  }
}

export default AsyncTask
